import ContentPageHeader from '../../../components/ui/contentPageHeader'
import FaqContent from '../../legal/FaqContent'
import '../../legal/faq.scss'

type Props = {
  /** Pre-rendered static homepage (no React): geo/country via injected script. */
  staticGeoSlot?: boolean
}

const LandingFaq = ({ staticGeoSlot = false }: Props) => {
  return (
    <section id='faq' className='landing-faq' aria-labelledby='landing-faq-heading'>
      <div className='container col-xxl-5 py-5'>
        <ContentPageHeader
          as='h2'
          id='landing-faq-heading'
          title='Frequently asked questions'
          subtitle='Everything you need to know about TinyInvoice.app'
        />
        <FaqContent staticGeoSlot={staticGeoSlot} />
      </div>
    </section>
  )
}

export default LandingFaq
